// extracted by mini-css-extract-plugin
export default {"vergasgold":"hsl(45, 54%, 58%)"};